import { ReactNode } from 'react';

// Text for screen readers only.
export function VisuallyHidden({ children, id }: { children: ReactNode; id?: string }) {
  return (
    <span className="visually-hidden" id={id}>
      {children}
    </span>
  );
}
